import { render, staticRenderFns } from "./ReportedListView.vue?vue&type=template&id=4c2c496c&"
import script from "./ReportedListView.vue?vue&type=script&lang=ts&"
export * from "./ReportedListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports